import {React} from 'common'
import {validationPatterns} from 'constants/auth'
import {FormCheckbox, FormContainer, FormTitle} from 'components/Control/Form'
import FormTextInput from 'components/Control/Form/FormTextInput'

const LoginForm = ({translate, control, errors}) => {
    return (
        <FormContainer>
            <FormTitle>{translate('welcome')}</FormTitle>
            <FormTextInput
                name={'email'}
                control={control}
                rules={{
                    required: true,
                    pattern: validationPatterns.EMAIL,
                }}
                fullWidth
                label={translate('email')}
                type="email"
                errors={errors}
            />
            <FormTextInput
                name={'password'}
                control={control}
                rules={{
                    required: true,
                }}
                fullWidth
                initialValue=""
                label={translate('password')}
                type="password"
                errors={errors}
            />
            <FormCheckbox
                name={'rememberMe'}
                control={control}
                label={translate('rememberMe')}
                defaultChecked={false}
            />
        </FormContainer>
    )
}

export default LoginForm
